<template>
  <CustomSelect
    class="w-100"
    inputId="attachmentTypePicker"
    inputLabel="نوع فایل"
    v-model="selectedType"
    :value="value"
    @input="$emit('input', $event)"
    :customOptions="attachmentTypes"
  ></CustomSelect>
</template>

<script>
export default {
  emits: ["getSelectedType"],
  props: {
    defaultSelectedType: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedType) {
      this.selectedType = this.defaultSelectedType;
    }
  },
  watch: {
    selectedType: {
      handler(val) {
        this.$emit("getSelectedType", val);
      },
    },
  },
  data() {
    return {
      selectedType: 1,
      attachmentTypes: [
        {
          text: "تصویر",
          value: 1,
        },
        {
          text: "صدا",
          value: 2,
        },
        {
          text: "ویدیو",
          value: 3,
        },
        {
          text: "PDF",
          value: 4,
        },
        {
          text: "فایل فشرده",
          value: 5,
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
